import { render, staticRenderFns } from "./OrderSource.vue?vue&type=template&id=b8cef0ae&scoped=true&"
import script from "./OrderSource.vue?vue&type=script&lang=js&"
export * from "./OrderSource.vue?vue&type=script&lang=js&"
import style0 from "./OrderSource.vue?vue&type=style&index=0&id=b8cef0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cef0ae",
  null
  
)

export default component.exports